import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { mediaUrl, baseURL } from "../axiosInterceptor/axiosInterceptorC";

// Async Thunk for Fetching Property Details
export const fetchmyPropertyDetails = createAsyncThunk(
  "property/fetchPropertyDetails",
  async (Pstatus, { rejectWithValue }) => {
    try {
      const login_id = localStorage.getItem("login_id");
      const response = await axios.post(`${baseURL}/fetchPropertyDetails_get`, {
        login_id,
        Pstatus,
      });

      return response.data.propertydetails || []; // Return empty array if no data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const propertySlice = createSlice({
  name: "myproperty",
  initialState: {
    myPropertydata: null, // Change to `null` instead of empty array
    loading1: false,
    error1: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchmyPropertyDetails.pending, (state) => {
        state.loading1 = true;
        state.error1 = null;
      })
      .addCase(fetchmyPropertyDetails.fulfilled, (state, action) => {
        state.loading1 = false;
        state.myPropertydata = action.payload.length ? action.payload : []; // Store `null` if empty
      })
      .addCase(fetchmyPropertyDetails.rejected, (state, action) => {
        state.loading1 = false;
        state.error1 = action.payload;
      });
  },
});


export default propertySlice.reducer;
